import { Users, Wallet } from "lucide-react";

export const PRICE_EST = { $: 15, $$: 40, $$$: 80, $$$$: 150 };
export const itemCost = (l) => PRICE_EST[(l.price_range || "").trim()] ?? null;

export function dayBudget(list, party) {
  const known = list.map((e) => itemCost(e.listing)).filter((c) => c != null);
  return { total: known.reduce((a, b) => a + b, 0) * party, missing: list.length - known.length };
}

export function BudgetBar({ items, party, setParty }) {
  const { total, missing } = dayBudget(items, party);
  return (
    <div data-testid="trip-budget" className="mt-6 rounded-2xl border border-[#26334D] bg-[#151C2C] p-4 flex flex-wrap items-center gap-4">
      <Wallet className="h-5 w-5 text-[#FFB800]" />
      <div className="flex-1 min-w-[180px]">
        <p className="text-xs uppercase tracking-wider text-slate-500">Estimated trip budget</p>
        <p data-testid="trip-budget-total" className="text-2xl font-extrabold">${total.toLocaleString()}</p>
        <p className="text-xs text-slate-500">Based on each place's price range ($≈15 · $$≈40 · $$$≈80 · $$$$≈150 per person){missing ? ` · ${missing} without price info` : ""}</p>
      </div>
      <label className="flex items-center gap-2 text-sm text-slate-300">
        <Users className="h-4 w-4" /> People
        <div className="flex items-center rounded-full border border-[#26334D]">
          <button data-testid="trip-party-minus" onClick={() => setParty(Math.max(1, party - 1))} className="px-3 py-1 hover:text-white">−</button>
          <span data-testid="trip-party-size" className="w-6 text-center font-semibold">{party}</span>
          <button data-testid="trip-party-plus" onClick={() => setParty(Math.min(20, party + 1))} className="px-3 py-1 hover:text-white">+</button>
        </div>
      </label>
    </div>
  );
}
